module.exports = __webpack_public_path__ + "img/zeitgard_erklaerung.e00fd28a.jpg";